import React from 'react';

import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

export interface IconCloseButtonProps extends SvgIconProps {}

const IconCloseButton: React.FC<IconCloseButtonProps> = ({ ...rest }) => (
  <SvgIcon viewBox="0 0 54 54" {...rest} width="54" height="54">
    <g filter="url(#filter0_d_1_490)">
      <mask id="path-1-outside-1_1_490" maskUnits="userSpaceOnUse" x="16" y="12" width="22" height="22" fill="black">
        <rect fill="white" x="16" y="12" width="22" height="22" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27 33C32.5228 33 37 28.5228 37 23C37 17.4772 32.5228 13 27 13C21.4772 13 17 17.4772 17 23C17 28.5228 21.4772 33 27 33ZM31.7914 17L33 18.2086L28.2086 23L33 27.7914L31.7914 29L27 24.2086L22.2086 29L21 27.7914L25.7914 23L21 18.2086L22.2086 17L27 21.7914L31.7914 17Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27 33C32.5228 33 37 28.5228 37 23C37 17.4772 32.5228 13 27 13C21.4772 13 17 17.4772 17 23C17 28.5228 21.4772 33 27 33ZM31.7914 17L33 18.2086L28.2086 23L33 27.7914L31.7914 29L27 24.2086L22.2086 29L21 27.7914L25.7914 23L21 18.2086L22.2086 17L27 21.7914L31.7914 17Z"
        fill="#6C7980"
      />
      <path
        d="M33 18.2086L33.7071 18.9157L34.4142 18.2086L33.7071 17.5015L33 18.2086ZM31.7914 17L32.4985 16.2929L31.7914 15.5858L31.0843 16.2929L31.7914 17ZM28.2086 23L27.5015 22.2929L26.7944 23L27.5015 23.7071L28.2086 23ZM33 27.7914L33.7071 28.4985L34.4142 27.7914L33.7071 27.0843L33 27.7914ZM31.7914 29L31.0843 29.7071L31.7914 30.4142L32.4985 29.7071L31.7914 29ZM27 24.2086L27.7071 23.5015L27 22.7944L26.2929 23.5015L27 24.2086ZM22.2086 29L21.5015 29.7071L22.2086 30.4142L22.9157 29.7071L22.2086 29ZM21 27.7914L20.2929 27.0843L19.5858 27.7914L20.2929 28.4985L21 27.7914ZM25.7914 23L26.4985 23.7071L27.2056 23L26.4985 22.2929L25.7914 23ZM21 18.2086L20.2929 17.5015L19.5858 18.2086L20.2929 18.9157L21 18.2086ZM22.2086 17L22.9157 16.2929L22.2086 15.5858L21.5015 16.2929L22.2086 17ZM27 21.7914L26.2929 22.4985L27 23.2056L27.7071 22.4985L27 21.7914ZM36 23C36 27.9706 31.9706 32 27 32V34C33.0751 34 38 29.0751 38 23H36ZM27 14C31.9706 14 36 18.0294 36 23H38C38 16.9249 33.0751 12 27 12V14ZM18 23C18 18.0294 22.0294 14 27 14V12C20.9249 12 16 16.9249 16 23H18ZM27 32C22.0294 32 18 27.9706 18 23H16C16 29.0751 20.9249 34 27 34V32ZM33.7071 17.5015L32.4985 16.2929L31.0843 17.7071L32.2929 18.9157L33.7071 17.5015ZM28.9157 23.7071L33.7071 18.9157L32.2929 17.5015L27.5015 22.2929L28.9157 23.7071ZM33.7071 27.0843L28.9157 22.2929L27.5015 23.7071L32.2929 28.4985L33.7071 27.0843ZM32.4985 29.7071L33.7071 28.4985L32.2929 27.0843L31.0843 28.2929L32.4985 29.7071ZM26.2929 24.9157L31.0843 29.7071L32.4985 28.2929L27.7071 23.5015L26.2929 24.9157ZM22.9157 29.7071L27.7071 24.9157L26.2929 23.5015L21.5015 28.2929L22.9157 29.7071ZM20.2929 28.4985L21.5015 29.7071L22.9157 28.2929L21.7071 27.0843L20.2929 28.4985ZM25.0843 22.2929L20.2929 27.0843L21.7071 28.4985L26.4985 23.7071L25.0843 22.2929ZM20.2929 18.9157L25.0843 23.7071L26.4985 22.2929L21.7071 17.5015L20.2929 18.9157ZM21.5015 16.2929L20.2929 17.5015L21.7071 18.9157L22.9157 17.7071L21.5015 16.2929ZM27.7071 21.0843L22.9157 16.2929L21.5015 17.7071L26.2929 22.4985L27.7071 21.0843ZM31.0843 16.2929L26.2929 21.0843L27.7071 22.4985L32.4985 17.7071L31.0843 16.2929Z"
        fill="white"
        mask="url(#path-1-outside-1_1_490)"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1_490"
        x="0"
        y="0"
        width="54"
        height="54"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="8" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_490" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_490" result="shape" />
      </filter>
    </defs>
  </SvgIcon>
);

export default IconCloseButton;
